module.exports = __webpack_public_path__ + "static/media/Roboto-BoldItalic.fd6e9700.ttf";